export default "__VITE_ASSET__DK_WSt88__"